import {BoundingBox} from '@phosphor-icons/react'
import clsx from 'clsx'
import React, {useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {DndProvider, useDrag, useDrop} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import {useFormContext, useWatch} from 'react-hook-form'
import Swal from 'sweetalert2'
import {ERROR_MESSAGE_SYSTEM, SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../util/functions'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import {useAssigment} from '../../../../hooks/limpieza/useAssigment'
import {
  AssigmentModel,
  CreatePhoneAssigmentModel,
  LayoutModelDto,
} from '../../../../model/assigment.model'
import {CleaningActivitiesColumnModel} from '../../../../model/creationCleaningActivities.model'
import {ViewAssignLayout} from '../../../../pages/Views/AssignmentCellphoneWrapper/table/view-assign-layout'
import {createPhoneAssigment} from '../../../../services/assigment.services'
import style from './index.module.scss'

interface ICampamento {
  CampamentoId: string
  CampamentoNombre: string
  TotalModulos?: number | 0
  TotalHabitaciones?: number | 0
  TotalCelulares?: number | 0
  TotalActividades?: number | 0
}

interface ICelular {
  Id: string
  NumeroCelular: string
  ProveedorServicio: string
  Modelo: string
  Marca: string
  Serie: string
  CampamentoId?: string | ''
  CampamentoNombre?: string | ''
}

interface IActividad {
  Id: string
  Descripcion: string
}

interface IListaCampamentoItem {
  campamento: ICampamento
  listaCelulares: ICelular[]
  listaActividades: IActividad[]
}

interface IListaCampamentos extends Array<IListaCampamentoItem> {}

const listaCampamentosInicial: IListaCampamentos = [
  {
    campamento: {CampamentoId: '1', CampamentoNombre: 'Campamento A'},
    listaCelulares: [
      //{ Id: '1', NumeroCelular: '+51 974 123 456', ProveedorServicio: 'Claro', Modelo: 'A50', Marca: 'SAMSUNG', Serie: 'A50SAN' },
    ],
    listaActividades: [
      //{ Id: '1', Descripcion: 'Moppeo pisos' },
    ],
  },
  {
    campamento: {CampamentoId: '2', CampamentoNombre: 'Campamento B'},
    listaCelulares: [
      // { Id: '1', NumeroCelular: '+51 974 123 456', ProveedorServicio: 'Claro', Modelo: 'A50', Marca: 'SAMSUNG', Serie: 'A50SAN' },
    ],
    listaActividades: [
      // { Id: '1', Descripcion: 'Moppeo pisos' },
    ],
  },
]

const listaCelularesInicial: ICelular[] = [
  {
    Id: '1',
    NumeroCelular: '+51 974 123 456',
    ProveedorServicio: 'Claro',
    Modelo: 'A50',
    Marca: 'SAMSUNG',
    Serie: 'A50SAN',
  },
  {
    Id: '2',
    NumeroCelular: '+51 974 123 457',
    ProveedorServicio: 'Movistar',
    Modelo: 'Mate X4',
    Marca: 'HUAWEI',
    Serie: 'MATX4H',
  },
]
const listaActividadesInicial: IActividad[] = [
  {Id: '1', Descripcion: 'Moppeo pisos'},
  {Id: '2', Descripcion: 'Barrido pisos'},
  {Id: '3', Descripcion: 'Limpieza ventanas'},
]

const ItemTypes = {
  CELULAR: 'celular',
  ACTIVIDAD: 'actividad',
}

const DraggableCelular = ({
  celular,
  index,
  celulares,
  selectedIds,
  setSelectedIds,
  lastSelectedIndex,
  setLastSelectedIndex,
  tipoData,
}: any) => {
  // const isActivo = !celular.EsAsignado
  const isSelected = (selectedIds || []).includes(celular.CelularId)
  const {selectedPhones} = useAssigment()
  const isPicked = selectedPhones.some((p) => p.CelularId === celular.CelularId)
  let numeroAsignados = 0
  if (tipoData === 'CAP') {
    //console.log('Asignaciones CAP => ', celular?.Asignaciones)
    numeroAsignados =
      new Set(
        celular?.Asignaciones?.filter((a) => a.CampamentoId !== null)?.map((a) => a.CampamentoId),
      ).size || 0
  } else if (tipoData === 'MOD') {
    //console.log('Asignaciones MOD => ', celular?.Asignaciones)
    numeroAsignados =
      new Set(celular?.Asignaciones?.filter((a) => a.ModuloId !== null)?.map((a) => a.ModuloId))
        .size || 0
  } else if (tipoData === 'PIS') {
    console.log('Asignaciones PIS => ', celular?.Asignaciones)

    numeroAsignados =
      new Set(celular?.Asignaciones?.filter((a) => a.PisoId !== null)?.map((a) => a.PisoId)).size ||
      0
  } else if (tipoData === 'HAB') {
    //console.log('Asignaciones HAB => ', celular?.Asignaciones)
    numeroAsignados =
      new Set(
        celular?.Asignaciones?.filter((a) => a.HabitacionId !== null)?.map((a) => a.HabitacionId),
      ).size || 0
  }

  const [{isDragging}, dragRef] = useDrag(
    () => ({
      type: ItemTypes.CELULAR,

      item: () => ({
        celularIds: isSelected ? selectedIds : [celular.CelularId],
      }),

      canDrag: true,

      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [selectedIds, isSelected],
  )

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    // if (!isActivo) return

    // SHIFT (rango)
    if (e.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index)
      const end = Math.max(lastSelectedIndex, index)

      const rangeIds = celulares
        .slice(start, end + 1)
        // .filter((c) => !c.EsAsignado)
        .map((c) => c.CelularId)

      setSelectedIds(rangeIds)
      return
    }

    // CTRL (multi select)
    if (e.ctrlKey) {
      setSelectedIds((prev) =>
        prev.includes(celular.CelularId)
          ? prev.filter((x) => x !== celular.CelularId)
          : [...prev, celular.CelularId],
      )
      setLastSelectedIndex(index)
      return
    }

    // Click normal
    setSelectedIds([celular.CelularId])
    setLastSelectedIndex(index)
  }

  return (
    <div
      ref={dragRef}
      onClick={handleClick}
      className={clsx('p-2 mb-2 rounded border select-none', {
        'border-blue-500 cursor-move': isSelected,
        [style.bgPicked]: isPicked,
        [style.bgSelected]: isSelected,
        // 'bg-white border-gray-300 cursor-move': isActivo && !isSelected,
        // 'bg-gray-300 border-gray-200 cursor-not-allowed opacity-60': !isActivo,
        'opacity-50': isDragging,
      })}
    >
      📱 {celular.NroCelular} {numeroAsignados > 0 && `(${numeroAsignados})`}
    </div>
  )
}

const DraggableActividad = ({actividad}: {actividad: CleaningActivitiesColumnModel}) => {
  const [{isDragging}, dragRef] = useDrag(() => ({
    type: ItemTypes.ACTIVIDAD,
    item: {actividadId: actividad.Id, type: ItemTypes.ACTIVIDAD},
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }))

  return (
    <div
      ref={dragRef}
      className={clsx('p-2 mb-2 bg-white rounded cursor-move', {
        'opacity-50': isDragging,
      })}
    >
      📝 {actividad.Actividad}
    </div>
  )
}

const DropCampamento = ({
  campamento,
  onDropCelular,
  onDropActividad,
  handleOpenActividades,
  handleOpenCelulares,
  handleActividades,
  handleCelulares,
  toggleListaDisponibles,
}: {
  campamento: ICampamento
  onDropCelular: (celularId: string, campamento: ICampamento) => void
  onDropActividad: (actividadId: string, campamento: ICampamento) => void
  handleOpenActividades: () => void
  handleOpenCelulares: () => void
  handleActividades: () => void
  handleCelulares: () => void
  toggleListaDisponibles: boolean
}) => {
  const [{isOver}, dropRef] = useDrop(() => ({
    accept: [ItemTypes.CELULAR, ItemTypes.ACTIVIDAD],
    drop: (item: {id: string; type: string}) => {
      if (item.type === ItemTypes.CELULAR) {
        onDropCelular(item.id, campamento)
      } else if (item.type === ItemTypes.ACTIVIDAD) {
        onDropActividad(item.id, campamento)
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }))

  return (
    <div
      className={clsx('card border card-xl-stretch min-w-350px mx-3 cursor-pointer', {
        'bg-light-success': isOver,
        'bg-light': !isOver,
      })}
      ref={dropRef}
    >
      <div className='card-header border-0 py-5 gap-4'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{campamento.CampamentoNombre}</span>
          {/* <LayoutProgressBar campa={campamento as any}></LayoutProgressBar> */}
        </h3>
        <div className='card-toolbar'>
          <BoundingBox className='me-2 text-muted mt-2' size={32} weight='duotone' />
        </div>
      </div>
      <div>
        <div className='card-p pt-5 bg-body flex-grow-1'>
          <div className='row g-0' onClick={() => console.log('CLICK VER MODULOS')}>
            <div className='col mr-8'>
              <div className='fs-7 text-muted fw-semibold'>Módulos</div>
              <div className='d-flex align-items-center'>
                <div className='fs-4 fw-bold'>{campamento.TotalModulos || 0}</div>
              </div>
            </div>
            <div className='col'>
              <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
              <div className='fs-4 fw-bold'>{campamento.TotalHabitaciones || 0}</div>
            </div>
          </div>
          <div className='row g-0 mt-8'>
            <div
              className='col mr-8'
              onClick={handleActividades}
              onDoubleClick={handleOpenActividades}
            >
              <div className='fs-7 text-muted fw-semibold'>Actividades</div>
              <div className='fs-4 fw-bold'>{campamento.TotalCelulares || 0}</div>
            </div>
            <div className='col' onClick={handleCelulares} onDoubleClick={handleOpenCelulares}>
              <div className='fs-7 text-muted fw-semibold'>Celulares</div>
              <div className='d-flex align-items-center'>
                <div className='fs-4 fw-bold'>{campamento.TotalActividades || 0}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const TotalComponent = ({
  setDataGroup,
  setIsReset,
  isReset,
  dataGroup,
  handleOpenActividades,
  handleOpenCelulares,
  handleAsignar,
  data,
  tipoData,
  loadModulesLayout,
  loadFloorsLayout,
  loadHabiationsLayout,
  selectedOptionName,
  selectedOption,
  loadCampsLayout,
  isLoadingLayout,
}: any) => {
  const [listaCampamentos, setListaCampamentos] =
    useState<IListaCampamentos>(listaCampamentosInicial)
  const [listaCelulares, setListaCelulares] = useState<ICelular[]>(listaCelularesInicial)
  const [listaActividades, setListaActividades] = useState<IActividad[]>(listaActividadesInicial)
  const [toggleListaDisponibles, setToggleListaDisponibles] = useState<boolean>(false) // false = celulares, true = actividades
  const [selectedIds, setSelectedIds] = useState<number[]>([])
  const [lastSelectedIndex, setLastSelectedIndex] = useState<number | null>(null)
  const {setValue, watch} = useFormContext()

  const handleBackgroundClick = () => {
    setSelectedIds([])
  }

  const {
    celularesDisponibles,
    actividadesDisponibles,
    loadingCelulares,
    getCelularesDisponibles,
    getLayout,
  } = useAssigment()
  useEffect(() => {
    if (isReset) {
      setIsReset(false)
      setListaCampamentos(listaCampamentosInicial)
      setListaCelulares(listaCelularesInicial)
      setListaActividades(listaActividadesInicial)
    }
  }, [isReset, setIsReset])

  const handleDropCelular = (dto: CreatePhoneAssigmentModel) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: `De asignar los celulares`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, asignar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              var {data: response} = await createPhoneAssigment(dto)
              if (!response.error) {
                ShowSnackBar(response.message ?? SUCCESS_MESSAGE_CREATE, 'success')
                if (dto.NivelAsignacion === 'CAP' || dto.NivelAsignacion === 'CAP-ALL') {
                  getLayout({
                    TipoData: 'CAP',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                } else if (dto.NivelAsignacion === 'MOD' || dto.NivelAsignacion === 'MOD-ALL') {
                  getLayout({
                    TipoData: 'MOD',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    CampamentoId: watch('CampamentoId'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                } else if (dto.NivelAsignacion === 'PIS' || dto.NivelAsignacion === 'PIS-ALL') {
                  getLayout({
                    TipoData: 'PIS',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    ModuloId: watch('ModuloId'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                } else if (dto.NivelAsignacion === 'HAB' || dto.NivelAsignacion === 'HAB-ALL') {
                  getLayout({
                    TipoData: 'HAB',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    PisoId: watch('PisoId'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                }
                const dtoCelulares = {
                  ClienteId: watch('ClienteIdCurrent'),
                  CompaniaId: watch('CompaniaIdCurrent'),
                  SiteId: watch('SiteIdCurrent'),
                  CampamentoId: watch('CampamentoId') || '',
                  pageNumber: 1,
                  size: 10000,
                }
                getCelularesDisponibles(dtoCelulares)
                setSelectedIds([])
              } else {
                ShowSnackBar(response.message ?? ERROR_MESSAGE_SYSTEM, 'error')
              }
            } catch (error) {
              // setLoadingCompleteStays(false)
              ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
            }
            Swal.close()
          } else if (result.isDenied) {
          }
        })
        .catch((error) => {
          // setLoadingCompleteStays(false)
          getSnackBarToast('Hubo un error ', 'error')
          console.log(error)
        })
    } catch (error) {
      // setLoadingCompleteStays(false)
      getSnackBarToast('Hubo un error ', 'error')
      console.log(error)
    }
  }

  const handleDropActividad = useCallback(
    (actividadId: string, layout: LayoutModelDto) => {
      const actividad = listaActividades.find((a) => a.Id === actividadId)
      if (!actividad) return
      var request: AssigmentModel = {
        ActividadId: actividadId,
        CelularId: null,
        CampamentoId: layout.CampamentoId,
        ModuloId: null,
        PisoId: null,
        HabitacionId: null,
        CamaId: null,
        TipoAsignacion: 1, // 1 - 'ACTIVIDAD'
      }
      console.log('request => ', request)
      // handleAsignar(request)
      // setListaCampamentos(prev =>
      //     prev.map(item => {
      //         if (item.campamento.CampamentoId !== campamento.CampamentoId) {
      //             return item
      //         }
      //         const yaExiste = item.listaActividades.some(a => a.Id === actividadId)
      //         if (yaExiste) return item
      //         return {
      //             ...item,
      //             listaActividades: [
      //                 ...item.listaActividades,
      //                 {
      //                     ...actividad,
      //                     CampamentoId: campamento.CampamentoId,
      //                     CampamentoNombre: campamento.CampamentoNombre,
      //                 },
      //             ],
      //         }
      //     })
      // )
    },
    [listaActividades],
  )

  const handleActividades = () => {
    setToggleListaDisponibles(true)
  }

  const handleCelulares = () => {
    setToggleListaDisponibles(false)
  }

  const handleTipoBusquedaChange = (tipo: 'disponibles' | 'asignadas') => {
    setValue('EsAsignado', tipo === 'asignadas')
  }

  const siteId = useWatch({name: 'SiteIdCurrent'})
  const campamentoId = useWatch({name: 'CampamentoId'})
  const EsAsignado = useWatch({name: 'EsAsignado'})

  useEffect(() => {
    if (siteId) {
      const dto = {
        ClienteId: watch('ClienteIdCurrent'),
        CompaniaId: watch('CompaniaIdCurrent'),
        SiteId: watch('SiteIdCurrent'),
        CampamentoId: watch('CampamentoId') || '',
        pageNumber: 1,
        size: 10000,
      }
      setSelectedIds([])
      getCelularesDisponibles(dto)
    }
  }, [siteId, campamentoId])

  return (
    <DndProvider backend={HTML5Backend}>
      <div className='row '>
        <div className='col-9'>
          <ViewAssignLayout
            data={data}
            loadCampsLayout={loadCampsLayout}
            selectedOptionName={selectedOptionName}
            selectedOption={selectedOption}
            tipoData={tipoData}
            loadModulesLayout={loadModulesLayout}
            loadFloorsLayout={loadFloorsLayout}
            loadHabiationsLayout={loadHabiationsLayout}
            isLoadingLayout={isLoadingLayout}
            handleDropActividad={handleDropActividad}
            handleDropCelular={handleDropCelular}
          />
        </div>
        <div className='col-3'>
          <div className='p-6 sticky-top'>
            <div className='card card-custom shadow-sm'>
              <div className='card-header' style={{borderBottomWidth: '3px'}}>
                <div className='py-5 d-flex flex-wrap'>
                  <h4 className='d-flex align-items-center'>
                    <BoundingBox className='me-2 text-muted' size={32} weight='duotone' />
                    Celulares
                  </h4>
                </div>
              </div>
              <div className='card-body' onClick={handleBackgroundClick}>
                {loadingCelulares ? (
                  <div className='p-6'>
                    <div className='d-flex justify-content-center align-items-center mb-2'>
                      <Spinner animation='border' />
                    </div>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      Cargando
                    </div>
                  </div>
                ) : celularesDisponibles.length === 0 ? (
                  <div className='p-6'>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No hay información
                    </div>
                  </div>
                ) : (
                  celularesDisponibles.map((cel, index) => (
                    <div key={cel.CelularId}>
                      <DraggableCelular
                        celular={cel}
                        index={index}
                        celulares={celularesDisponibles}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        lastSelectedIndex={lastSelectedIndex}
                        setLastSelectedIndex={setLastSelectedIndex}
                        tipoData={tipoData}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      {/* <Tablero /> */}
    </DndProvider>
  )
}

const TotalComponentWrapper = ({
  setDataGroup,
  setIsReset,
  isReset,
  dataGroup,
  handleOpenActividades,
  handleOpenCelulares,
  handleAsignar,
  data,
  tipoData,
  loadModulesLayout,
  loadFloorsLayout,
  loadHabiationsLayout,
  selectedOptionName,
  selectedOption,
  loadCampsLayout,
  isLoadingLayout,
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <TotalComponent
        setDataGroup={setDataGroup}
        setIsReset={setIsReset}
        isReset={isReset}
        dataGroup={dataGroup}
        handleOpenActividades={handleOpenActividades}
        handleOpenCelulares={handleOpenCelulares}
        handleAsignar={handleAsignar}
        data={data}
        tipoData={tipoData}
        loadModulesLayout={loadModulesLayout}
        loadFloorsLayout={loadFloorsLayout}
        loadHabiationsLayout={loadHabiationsLayout}
        selectedOptionName={selectedOptionName}
        selectedOption={selectedOption}
        loadCampsLayout={loadCampsLayout}
        isLoadingLayout={isLoadingLayout}
      />
      {/* <pre>{JSON.stringify(WAT, null, 2)}</pre> */}
    </DndProvider>
  )
}

export {TotalComponentWrapper}
